// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".fe09efacaf547c035df68c12761244a3ff7419fb.chunk.bundle.js";
};